import { renderCallback } from "./blueprint";
export function renderComponent(component) {
    return {
        instanceCallbacks: [
            renderCallback(function () { return component; }),
        ],
    };
}
export default renderComponent;

//# sourceMappingURL=renderComponent.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reassemble/lib/renderComponent.js
// module id = 79
// module chunks = 0